var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 34,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M34.136 17c0-9.339-7.57-16.91-16.909-16.91C7.89.09.318 7.662.318 17c0 8.44 6.183 15.435 14.267 16.704V21.888h-4.293V17h4.293v-3.725c0-4.238 2.525-6.579 6.387-6.579 1.85 0 3.785.33 3.785.33v4.162h-2.132c-2.1 0-2.756 1.303-2.756 2.641V17h4.69l-.75 4.888h-3.94v11.816C27.953 32.435 34.136 25.44 34.136 17Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "facebook_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.318.09h33.818V33.91H.318z"
  })))));
};
export default SvgFacebook;